import { Service, LiveData } from '@toeverything/infra';

import { FolderTree } from '../entities/folder-tree';
import type { DocRecord, DocsService } from '../../doc';
import type { WorkbenchService } from '../../workbench';
import type { AgentBetaStore } from '../../ys-ai/stores/agent-store-beta';
import type { DocTitleUniquenessService } from './doc-title-uniqueness';
export class OrganizeService extends Service {
  folderTree = this.framework.createEntity(FolderTree);

  shimmer = {
    isShimmerEnabled$: new LiveData(false),
    shimmerTargetId$: new LiveData(''),
  };
  shouldnotCollapseNodes$ = new LiveData<string[]>([]);
  conflictDocs$ = new LiveData<any[]>([]);

  constructor(
    private readonly docsService: DocsService, // DocsService
    private readonly workbenchService: WorkbenchService, // WorkbenchService
    private readonly agentBetaStore: AgentBetaStore, // AgentServiceBeta
    private readonly docTitleUniquenessService: DocTitleUniquenessService
  ) {
    super();
    this.agentBetaStore.conflictDocs$.subscribe(conflictDocs => {
      console.log('aaaaaaaconflictDocs', conflictDocs);
      this.updateAllNodesConflictStatus(conflictDocs);
    });
    window.addEventListener('docDeleted', this.docDeletedHandler);
  }

  enableShimmer(targetId: string) {
    this.shimmer.isShimmerEnabled$.next(true);
    this.shimmer.shimmerTargetId$.next(targetId);
  }
  addCollapseNode(nodeId: string) {
    this.shouldnotCollapseNodes$.next([
      ...this.shouldnotCollapseNodes$.value,
      nodeId,
    ]);
  }
  expandAllParentNodes(nodeId: string) {
    const node = this.folderTree.folderNodeByDocId$(nodeId)?.value;
    if (!node) return;

    // 添加当前节点
    this.addCollapseNode(nodeId);

    // 递归添加所有父节点
    let parentNodeId = node.info$.value?.parentId;
    while (parentNodeId) {
      const parentNode = this.folderTree.folderNode$(parentNodeId)?.value;
      const parentNodeDocId = parentNode?.info$.value?.data;
      if (parentNodeDocId) {
        this.addCollapseNode(parentNodeDocId);
      }

      parentNodeId = parentNode?.info$?.value?.parentId;
    }
  }

  disableShimmer() {
    this.shimmer.isShimmerEnabled$.next(false);
    this.shimmer.shimmerTargetId$.next('');
  }
  createArticleWithId = async ({
    options,
    isFirstCreate = true,
  }: {
    options: {
      title?: string;
      mode?: 'page' | 'edgeless';
      addToOrganize?: boolean;
      doc_id: string;
      parentDocId: string | undefined;
    };
    isFirstCreate: boolean;
  }) => {
    const {
      title = '',
      mode = 'page',
      addToOrganize = true,
      parentDocId,
    } = options;
    console.log('aaaaaaadocId', options);

    // 2. 创建新文档
    return new Promise<DocRecord>((resolve, reject) => {
      // 确定目标文件夹节点
      let targetFolder = this.folderTree.rootFolder;
      if (parentDocId) {
        const folderNode$ = this.folderTree.folderNodeByDocId$(parentDocId);
        if (folderNode$.value) {
          targetFolder = folderNode$.value;
        }
      }

      // 生成唯一的默认标题
      const defaultTitle =
        title ||
        this.docTitleUniquenessService.generateDefaultTitle(targetFolder);

      const docRecord = this.docsService.createDoc({
        title: defaultTitle,
        primaryMode: mode,
        id: options.doc_id,
      });

      const docId = docRecord.id;

      // 4. 添加到组织结构（可选）
      if (addToOrganize) {
        try {
          if (parentDocId) {
            // this.docsService.addLinkedDoc(parentDocId, docId).catch(e => {
            //   console.log('###aaaaaaaaaddLinkedDocError', e);
            // });

            const folderNode$ = this.folderTree.folderNodeByDocId$(parentDocId);
            folderNode$.value?.createLink(
              'doc',
              docId,
              folderNode$.value?.indexAt('before')
            );
            this.expandAllParentNodes(parentDocId);
          } else {
            const rootFolder = this.folderTree.rootFolder;
            rootFolder.createLink(
              'doc',
              docId,
              rootFolder.indexAt('before') // 添加到最前面
            );
          }

          // 5. 打开文档
          if (isFirstCreate) {
            this.workbenchService.workbench.openDoc(
              `${docId}?refer=ai_created`
            );
          }
          resolve(docRecord);
        } catch (error) {
          console.warn('添加到组织结构失败:', error);
          reject();
        }
      } else {
        reject();
      }
    });
  };

  // modify doc title
  async updateDocTitle(doc_id: string, title: string) {
    return new Promise((resolve, reject) => {
      const folderNode = this.folderTree.folderNodeByDocId$(doc_id).value;

      if (!folderNode) {
        reject();
        return;
      }

      this.docTitleUniquenessService
        .ensureUniqueTitleInFolder(doc_id, folderNode, title)
        .then(uniqueTitle => {
          resolve(uniqueTitle);
        })
        .catch(() => {
          reject();
        });
    });
  }

  // 新增方法：更新所有节点的冲突状态
  private updateAllNodesConflictStatus(conflictDocs: any[]) {
    console.log('开始更新所有节点冲突状态');

    const conflictDocIds = conflictDocs.map(doc => doc.doc_id);
    this.conflictDocs$.next(conflictDocIds);
  }
  private docDeletedHandler = (event: CustomEvent) => {
    const deletedDocId = event.detail;
    const folderNode = this.folderTree
      .folderNodeByDocId$(deletedDocId)
      .getValue();
    if (folderNode) {
      // 🔥 递归删除所有子文档
      const deleteNodeAndChildren = (currentNode: any) => {
        const children = currentNode.sortedChildren$.getValue();
        children.forEach((child: any) => {
          const childInfo = child.info$.getValue();
          if (childInfo?.type === 'doc') {
            // 递归删除子文档
            if (child.id) {
              child.delete();
            }
          }
          // 递归处理子节点的子节点
          deleteNodeAndChildren(child);
        });
      };

      // 先删除所有子节点
      deleteNodeAndChildren(folderNode);

      // 最后删除当前节点

      folderNode.delete();
    }
  };
  override dispose() {
    window.removeEventListener('docDeleted', this.docDeletedHandler);
    super.dispose();
  }
}
